import React from 'react'
import { Link } from "react-router-dom";

const HybridSolarPowerPlant = () => {
  return (
    <>


      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Hybrid Solar Power Plant</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>Hybrid Solar Power Plant</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/Hybrid.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">Hybrid Solar Power Plant – Yogesh Solar Energy</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      A Hybrid Solar Power Plant is an advanced energy solution that combines the benefits of solar power, battery storage, and grid connectivity to ensure uninterrupted electricity supply. At Yogesh Solar Energy, we provide customized hybrid solar systems designed to maximize efficiency, reduce electricity costs, and provide reliable power even during outages.
                    </p>
                    <h3 className="mb-20">What is a Hybrid Solar Power System?</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      A hybrid solar system integrates solar panels with battery storage and the main electricity grid. During the day, solar panels generate electricity to power your home or business. Excess energy is stored in batteries for later use, ensuring power availability at night or during grid failures.
                    </p>
                    {/* <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className="mb-3">
                        <h3 className="mb-3">Our Hybrid Solar Solutions Include:</h3>
                      </div>
                      <ul className="list">
                        <li><i className="far fa-check-double" />⚡ Solar Panel Installation – High-efficiency panels for maximum power generation</li>
                        <li><i className="far fa-check-double" /> 🔋 Battery Storage System – Store excess energy for uninterrupted usage</li>
                        <li><i className="far fa-check-double" /> 🔌 Grid Integration – Seamless switching between solar, battery, and grid power</li>
                        <li><i className="far fa-check-double" /> 🛠️ Smart Inverter Technology – Optimizes energy usage and performance</li>
                        <li><i className="far fa-check-double" /> 📊 Monitoring System – Track performance and energy savings in real-time</li>
                       
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default HybridSolarPowerPlant